import {FC} from 'react'
import find from 'lodash/find'

type Props = {
  status: String
}

const statusList = [
  {
    id: 'ship',
    name: 'Ship',
    color: 'badge badge-light-dark',
  },
  {
    id: 'pickup',
    name: 'Pickup',
    color: 'badge badge-light-primary',
  },
]

const DeliveryType: FC<Props> = ({status}: any) => {
  if (status) {
    const obj = find(statusList, {id: status.toLowerCase()})
    return obj ? <span className={`badge ${obj.color}`}>{obj.name}</span> : status
  }
  return null
}

export default DeliveryType
